export default function (arr, format = "Y M D") {
  let data;
  if (typeof arr === "string") {
    data = arr.split("-").map(a => parseInt(a));
  } else {
    data = arr;
  }
  if (data) {
    const tmp = [...data];
    tmp[1]--;
    const date = new Date(...tmp);
    const days = ["일", "월", "화", "수", "목", "금", "토"];
    const Y = date.getFullYear();
    const M = date.getMonth() + 1;
    const MM = (date.getMonth() + 1).toString().padStart(2, "0");
    const D = date.getDate();
    const DD = date.getDate().toString().padStart(2, "0");
    const day = days[date.getDay() - 1];
    const hh = date.getHours().toString().padStart(2, "0");
    const mm = date.getMinutes().toString().padStart(2, "0");
    if (format === "Y M D") return `${Y}년 ${M}월 ${D}일`;
    if (format === "Y M D (day)") return `${Y}년 ${M}월 ${D}일 (${day})`;
    if (format === "Y M D hh:mm") return `${Y}년 ${M}월 ${D}일 ${hh}:${mm}`;
    if (format === "Y.M.D") return `${Y}.${M}.${D}`;
    if (format === "Y.M.D hh:mm") return `${Y}.${M}.${D} ${hh}:${mm}`;
    if (format === "Y.MM.DD") return `${Y}.${MM}.${DD}`;
    if (format === "Y.MM.DD hh:mm") return `${Y}.${MM}.${DD} ${hh}:${mm}`;
    if (format === "Y-MM-DD") return `${Y}-${MM}-${DD}`;
    if (format === "Y-MM-DD hh:mm") return `${Y}-${MM}-${DD} ${hh}:${mm}`;
    return "";
  }
  return "";
}
